exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".draftAlert-8425a{display:flex;flex-direction:column;align-items:flex-end}.draftAlert-8425a .resetButton-adda5{margin-bottom:5px}", ""]);

// Exports
exports.locals = {
	"draftAlert": "draftAlert-8425a",
	"resetButton": "resetButton-adda5"
};